export default "__VITE_ASSET__44598218__"